import { Box, Grid } from '@material-ui/core';
import { CheckoutSessionCriteria } from '@nemuru-eng/js-api-client';

import { PaymentIntentBadge } from '@/components/modules/CheckoutSession/List/utils/getDataGridFields/components/desktop/PaymentIntentBadge';
import { Text } from '@/components/shared/components/Text';

export const selectedPaymentIntentColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.38,
    field: 'selectedPaymentIntent',
    sortable: false,
    align: 'left',
    headerName: <Text tId={'SELECTED_PAYMENT_INTENT'} />,
    renderCell: (rowData: { row: CheckoutSessionCriteria }) => {
      return (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              whiteSpace: 'break-spaces',
              lineHeight: '1.43',
              width: '100%',
            }}
          >
            <Grid container alignItems={'center'}>
              <Grid item xs={12}>
                <Box p={1}>
                  <PaymentIntentBadge paymentIntent={rowData.row.selectedPaymentIntent} />
                </Box>
              </Grid>
            </Grid>
          </div>
        </>
      );
    },
  };
};
